import { format } from "date-fns";

// builds the timestamped filename shared by every Decision Engine CSV export
export function buildCsvFilename(name: string, kind: string): string {
  const slug = name.toLowerCase().replace(/[^a-z0-9]/g, "_");
  return `${slug}-${kind}-${format(new Date(), "yyyyMMddHHmmss")}.csv`;
}
